<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Print invoices By Key
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys"
										v-model="spastedData"
										solo
									></v-textarea>
              	</v-flex>
                <!-- <v-flex xs12 class="text-xs-center" pb-5>
                  <v-btn color="primary" @click="searchByKey()">fetch leads by key</v-btn>
                  <v-btn color="primary" @click="searchByDoc()">fetch leads by document</v-btn>
                </v-flex> -->
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  {{leads.length}} / {{totalW}}
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Leads
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap v-if="leads && leads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in leads" :key="l+'-lead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Not found keys
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap v-if="nKeys && nKeys.length">
                    <v-flex xs12 py-1 v-for="(key, kk) in nKeys" :key="kk+'-kkeyy'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="key" xs6 md6>
                            <div class="caption grey--text ">Key / Document Number</div>
                            <v-tooltip top>
                              <span slot="activator">{{ key }}</span>
                              <span>{{ key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex xs12 xs6 md6>
                            <v-btn 
                              v-clipboard:copy="key"
                              v-clipboard:success="clipboardSuccessHandler"
                              v-clipboard:error="clipboardErrorHandler"
                              flat small color="primary">copy</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <!-- <v-btn color="primary" @click="exporLeadsByKey()" :loading="loading" :disabled="loading">export leads</v-btn> -->
							
              <v-btn @click="printAllLeads(true)" :loading="loading" :disabled="loading" color="success" >
                Shipping Labels
              </v-btn>
              
              <v-btn @click="printAllLeads(true, true)" :loading="loading" :disabled="loading" color="success" >
                Sorted Shipping Labels
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <!-- <v-btn color="primary" @click="exporLeadsByKey()" :loading="loading" :disabled="loading">export leads</v-btn> -->
							
              <v-btn @click="printAllLeads(true, false, 'ar')" :loading="loading" :disabled="loading" color="success" >
                Shipping Labels AR
              </v-btn>
              <v-btn @click="printAllLeads(true, true, 'ar')" :loading="loading" :disabled="loading" color="success" >
                Sorted Shipping Labels AR
              </v-btn>
              <v-btn @click="printAllLeads(true, false, 'en')" :loading="loading" :disabled="loading" color="success" >
                Shipping Labels EN
              </v-btn>
              <v-btn @click="printAllLeads(true, true, 'en')" :loading="loading" :disabled="loading" color="success" >
                Sorted Shipping Labels EN
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Invoices
						</v-card-title>
            <v-card-actions>
							<v-btn @click="print()" :loading="loading" :disabled="loading" color="success" >
                Print
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 pa-1>
									<iframe width="100%" height="600px" id="frame" frameborder="0"></iframe>
              	</v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
import json2csv from 'json2csv'
const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const invoicing_api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/gen_invoices/generate'
const headers = {
  'Accept': 'application/json'
}

export default {
  data(){
    return {
			loading: false,
      pastedData:null,
      spastedData:null,
			delimiter:',',
      pKeys:[],
      leads:[],
      dleads:[],
      ftleads:[],
      nKeys:[],
      eleads:[],
      totalW:0,
      totalK:0,
      dArray:[],
      oArray:[],
      nArray:[],
      mArray:[],
      eArray:[],
      newShippingStatus:null,
      shippingStatus:[],
      fsd:null,
      fTLDate:null,
      warehouses:[],
      selectedWarehouse:null,
      products:[],
      src:null,
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    async searchByKey(){
      this.leads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          key: x.trim()
        } 
      });
      this.totalW = a.length;
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          let l = await store.collection('leads').doc(r.key).get().then(x=>x.data())
          if(l){
            if(!l.key) l.key = r.key
            this.leads.push(l)
            this.eleads.push(l)
          } else {
            this.nKeys.push(r.key)
          }
        }
        console.log(this.leads)
      })()
    },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)
          return array.map(it => {
            return Object.values(it).toString()
          }).join('\n')
    },
    pivot(arr) {
        var mp = new Map();
        
        function setValue(a, path, val) {
            if (Object(val) !== val) { // primitive value
                var pathStr = path.join('.');
                var i = (mp.has(pathStr) ? mp : mp.set(pathStr, mp.size)).get(pathStr);
                a[i] = val;
            } else {
                for (var key in val) {
                    setValue(a, key == '0' ? path : path.concat(key), val[key]);
                }
            }
            return a;
        }
        
        var result = arr.map( obj => setValue([], [], obj) );
        return [[...mp.keys()], ...result];
    },
    toCsv(arr) {
        return arr.map( row => 
            row.map ( val => isNaN(val) ? JSON.stringify(val) : +val ).join(',')
        ).join('\n');
    },
    exporLeadsByKey(){
      let leads = [...this.eleads]
      console.log('------------------------------------');
      console.log(leads);
      console.log('------------------------------------');
      let exportArray = []
      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          const lead = leads[key];
          console.log('------------------------------------', lead);

          let k = lead.status_timeline ? Object.keys(lead.status_timeline) : null
          let lastcdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i)=>{return {...x, key:k[i]}})
          .filter(x => x.key == 'dispatch')
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null
          let Sdates = {}
          let kShip = lead.shipping_status_timeline ? Object.keys(lead.shipping_status_timeline) : null
          let lastSdate = lead.shipping_status_timeline ? Object.values(lead.shipping_status_timeline)
          .forEach((x, i)=>{ Sdates[kShip[i]] = x.date }) : []

          if (lead.order) {
            let order = lead.order
            for (let i = 0; i < order.length; i++) {
              const item = order[i];
              //delete lead.order
              exportArray.push({
                ...lead,
                item_name: item.product,
                item_sku: item.sku,
                item_unite_price: item.baseprice,
                item_quantity: item.quantity,
                last_dispatch_date: lastcdate ? lastcdate.date : null,
                last_dispatch_agent: lastcdate ? lastcdate.agent : null,
                ...Sdates
              })
            }
          }
        }
      }
      console.log('------------------------------------');
      console.log(exportArray);
      console.log('------------------------------------');
      //let a = this.toCsv(this.pivot(exportArray))
      let a = json2csv.parse(exportArray)
      console.log(a)
      

      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `leads_export.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    print(){
      var wnd = window.open("about:blank", "");
      wnd.document.write(this.src);
      wnd.document.close();
      wnd.print()

    },
    async printAllLeads(shipping = false, sorted_sku = false, language = 'ar') {
      this.loading = true
      let keys = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
      let a = await axios.post(`${invoicing_api}`, {orders:keys, sorted_sku, shipping, language }, headers).then(x=>x.data)
      document.getElementById('frame').src = "data:text/html;charset=utf-8," + escape(a)
      this.src = a
      // var wnd = window.open("about:blank", "");
      // wnd.document.write(a);
      // wnd.document.close();
      this.loading = false
      console.log(a)
    }
    
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
		beta:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
    let keys = [
      '-M6mPdwDlLY7ckmNmcq8',
      '-M85DEOr1NHSkenbdWS3',
      '-M6u5fvp4SLAkyJOVnMV',
      '-M7jKaJ0HvEjUJ3MQvs1',
      '-M7g_vq9bauiIINItqQl',
      '-M7bBtL3Vf1sPiUjDTyz',
      '-M6nXvNvGO7bhKpZLtYT',
      '-M6EVaTv5xoPEhywmh1A',
      '-M6eoUklVb05ZEmaUOvR',
      'aad'
    ];
    
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
